/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoadingCapabilitiesAvailability } from './LoadingCapabilitiesAvailability';
import {
    LoadingCapabilitiesAvailabilityFromJSON,
    LoadingCapabilitiesAvailabilityFromJSONTyped,
    LoadingCapabilitiesAvailabilityToJSON,
    LoadingCapabilitiesAvailabilityToJSONTyped,
} from './LoadingCapabilitiesAvailability';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';
import type { LocationType } from './LocationType';
import {
    LocationTypeFromJSON,
    LocationTypeFromJSONTyped,
    LocationTypeToJSON,
    LocationTypeToJSONTyped,
} from './LocationType';

/**
 * 
 * @export
 * @interface DeliveryLocationInfoDraft
 */
export interface DeliveryLocationInfoDraft {
    /**
     * 
     * @type {LocationType}
     * @memberof DeliveryLocationInfoDraft
     */
    locationType?: LocationType;
    /**
     * Only useful when locationType is DistributionWarehouse. This is the brand of the distribution warehouse. See `GET /v1/distribution-warehouse-brands/list` for the brands FreightSimple recognises
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    distributionWarehouseBrand?: string;
    /**
     * Name of the business at this location
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    businessName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    city?: string;
    /**
     * State or province code for the location
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    stateOrProvinceCode?: string;
    /**
     * Postal code for the location
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    postalCode?: string;
    /**
     * 
     * @type {CountryCode}
     * @memberof DeliveryLocationInfoDraft
     */
    countryCode?: CountryCode;
    /**
     * First line of the address
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    addressLine?: string;
    /**
     * Second line of the address
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    addressLine2?: string;
    /**
     * Time the earliest time the carrier can visit the location for pickup or delivery
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    openFrom?: string;
    /**
     * Time the latest time the carrier can visit the location for pickup or delivery
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    openUntil?: string;
    /**
     * Instructions for the carrier at this location. Delivery notes are printed on the bill of lading as written, and notes are passed to the carrier with the booking, where some carriers shorten them. Send a deadline in `deadline`, not here: a date in the notes has been read by carriers as the day to deliver
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    notes?: string;
    /**
     * Name of the best contact for this location
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    contactName?: string;
    /**
     * Phone number for the best contact for this location
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    contactPhoneNumber?: string;
    /**
     * Extension for the contact phone number
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    contactPhoneNumberExtension?: string;
    /**
     * Email address for the best contact for this location
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    contactEmail?: string;
    /**
     * Reference number for this pickup or delivery
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    referenceNumber?: string;
    /**
     * Kept only where a deadline applies: a pickup or delivery at a DistributionWarehouse, unless its brand refuses one (supportsDeliveryDeadline false on GET /v1/distribution-warehouse-brands/list), or a TradeShow delivery. Anywhere else it is ignored when the shipment is quoted. For pickups this is the last free day for the shipment. For deliveries it is the MABD (Must Arrive By Date)
     * @type {Date}
     * @memberof DeliveryLocationInfoDraft
     */
    deadline?: Date;
    /**
     * Booth number are required for trade shows
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    boothNumber?: string;
    /**
     * If true, the carrier will need to drive inside the facility to pick up or deliver the shipment
     * @type {boolean}
     * @memberof DeliveryLocationInfoDraft
     */
    specialServiceInsideRequired?: boolean;
    /**
     * If true, the carrier will need to use a lift gate for the pickup or delivery
     * @type {boolean}
     * @memberof DeliveryLocationInfoDraft
     */
    specialServiceLiftGateRequired?: boolean;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof DeliveryLocationInfoDraft
     */
    hasShippingDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof DeliveryLocationInfoDraft
     */
    hasForklift?: LoadingCapabilitiesAvailability;
    /**
     * If true, the carrier will need to schedule an appointment for the delivery
     * @type {boolean}
     * @memberof DeliveryLocationInfoDraft
     */
    specialServiceAppointmentRequired?: boolean;
    /**
     * Amazon Reference ID for a delivery to an Amazon distribution warehouse (locationType is DistributionWarehouse and distributionWarehouseBrand is 'amazon'). On draft creation both ids are packed into referenceNumber server-side; on reads they are unpacked from it
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    amazonReferenceId?: string;
    /**
     * Amazon Shipment ID for a delivery to an Amazon distribution warehouse (locationType is DistributionWarehouse and distributionWarehouseBrand is 'amazon'). On draft creation both ids are packed into referenceNumber server-side; on reads they are unpacked from it
     * @type {string}
     * @memberof DeliveryLocationInfoDraft
     */
    amazonShipmentId?: string;
}



/**
 * Check if a given object implements the DeliveryLocationInfoDraft interface.
 */
export function instanceOfDeliveryLocationInfoDraft(value: object): value is DeliveryLocationInfoDraft {
    return true;
}

export function DeliveryLocationInfoDraftFromJSON(json: any): DeliveryLocationInfoDraft {
    return DeliveryLocationInfoDraftFromJSONTyped(json, false);
}

export function DeliveryLocationInfoDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryLocationInfoDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'locationType': json['locationType'] == null ? undefined : LocationTypeFromJSON(json['locationType']),
        'distributionWarehouseBrand': json['distributionWarehouseBrand'] == null ? undefined : json['distributionWarehouseBrand'],
        'businessName': json['businessName'] == null ? undefined : json['businessName'],
        'city': json['city'] == null ? undefined : json['city'],
        'stateOrProvinceCode': json['stateOrProvinceCode'] == null ? undefined : json['stateOrProvinceCode'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryCode': json['countryCode'] == null ? undefined : CountryCodeFromJSON(json['countryCode']),
        'addressLine': json['addressLine'] == null ? undefined : json['addressLine'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'openFrom': json['openFrom'] == null ? undefined : json['openFrom'],
        'openUntil': json['openUntil'] == null ? undefined : json['openUntil'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'contactName': json['contactName'] == null ? undefined : json['contactName'],
        'contactPhoneNumber': json['contactPhoneNumber'] == null ? undefined : json['contactPhoneNumber'],
        'contactPhoneNumberExtension': json['contactPhoneNumberExtension'] == null ? undefined : json['contactPhoneNumberExtension'],
        'contactEmail': json['contactEmail'] == null ? undefined : json['contactEmail'],
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'deadline': json['deadline'] == null ? undefined : (new Date(json['deadline'])),
        'boothNumber': json['boothNumber'] == null ? undefined : json['boothNumber'],
        'specialServiceInsideRequired': json['specialServiceInsideRequired'] == null ? undefined : json['specialServiceInsideRequired'],
        'specialServiceLiftGateRequired': json['specialServiceLiftGateRequired'] == null ? undefined : json['specialServiceLiftGateRequired'],
        'hasShippingDock': json['hasShippingDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['hasShippingDock']),
        'hasForklift': json['hasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['hasForklift']),
        'specialServiceAppointmentRequired': json['specialServiceAppointmentRequired'] == null ? undefined : json['specialServiceAppointmentRequired'],
        'amazonReferenceId': json['amazonReferenceId'] == null ? undefined : json['amazonReferenceId'],
        'amazonShipmentId': json['amazonShipmentId'] == null ? undefined : json['amazonShipmentId'],
    };
}

  export function DeliveryLocationInfoDraftToJSON(json: any): DeliveryLocationInfoDraft {
      return DeliveryLocationInfoDraftToJSONTyped(json, false);
  }

  export function DeliveryLocationInfoDraftToJSONTyped(value?: DeliveryLocationInfoDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationType': LocationTypeToJSON(value['locationType']),
        'distributionWarehouseBrand': value['distributionWarehouseBrand'],
        'businessName': value['businessName'],
        'city': value['city'],
        'stateOrProvinceCode': value['stateOrProvinceCode'],
        'postalCode': value['postalCode'],
        'countryCode': CountryCodeToJSON(value['countryCode']),
        'addressLine': value['addressLine'],
        'addressLine2': value['addressLine2'],
        'openFrom': value['openFrom'],
        'openUntil': value['openUntil'],
        'notes': value['notes'],
        'contactName': value['contactName'],
        'contactPhoneNumber': value['contactPhoneNumber'],
        'contactPhoneNumberExtension': value['contactPhoneNumberExtension'],
        'contactEmail': value['contactEmail'],
        'referenceNumber': value['referenceNumber'],
        'deadline': value['deadline'] == null ? undefined : ((value['deadline']).toISOString().substring(0,10)),
        'boothNumber': value['boothNumber'],
        'specialServiceInsideRequired': value['specialServiceInsideRequired'],
        'specialServiceLiftGateRequired': value['specialServiceLiftGateRequired'],
        'hasShippingDock': LoadingCapabilitiesAvailabilityToJSON(value['hasShippingDock']),
        'hasForklift': LoadingCapabilitiesAvailabilityToJSON(value['hasForklift']),
        'specialServiceAppointmentRequired': value['specialServiceAppointmentRequired'],
        'amazonReferenceId': value['amazonReferenceId'],
        'amazonShipmentId': value['amazonShipmentId'],
    };
}

